import type React from "react";

import { Inline } from "@/design-system/Inline";
import { useTranslation } from "@/translations";

import { Translate01Icon } from "../Icons/Translate01Icon";

export function AutoTranslatedLabel(): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Inline gap="xs" align="center" wrap={false}>
      <Translate01Icon size={16} tone="secondary" />
      <span className="text-caption text-text-secondary">{t("common.label.this-content-is-auto-translated")}</span>
    </Inline>
  );
}
